import { render, staticRenderFns } from "./IconSvgNewspaper.vue?vue&type=template&id=0e9f2cb6&scoped=true&"
import script from "./IconSvgNewspaper.vue?vue&type=script&lang=js&"
export * from "./IconSvgNewspaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9f2cb6",
  null
  
)

export default component.exports